export default {
  methods: {

    getStatusString(donor) {
      let className = '';
      if (donor.status === 'complete') {
        className = 'txt-green';
      }
      if (donor.status === 'incomplete') {
        className = 'txt-red';
      }

      return `<span class="${className} status round-up-status">${donor.status.replace('complete', 'active')}</span>`;
    },
    donorPhoneIsOn(donor) {
      //number != null AND enabled AND unsubscribed = 0 AND (verified = 1 OR imported = 1) pseudocode from slack
      return donor.phone && donor.phone.number && !donor.phone.is_unsubscribed && donor.phone.is_enabled
          && (donor.phone.is_verified || donor.phone.is_imported);
    },
  },
};
